import styled from 'styled-components'
import { useTranslation } from '@/lang'

interface Props {
  title: React.ReactNode
  totalCount?: number
}

export const ReviewSectionTitle = ({ title, totalCount }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      {title}
      {totalCount !== undefined && totalCount > 0 && (
        <>
          <StyledPoint> {totalCount < 10000 ? totalCount.toLocaleString() : '9,999+'}</StyledPoint>
          {t('review.reviewUnit')}
        </>
      )}
    </>
  )
}

const StyledPoint = styled.span`
  color: ${({ theme }) => theme.colors.orange};
`
